'use strict';

const commonHelpers = require('../helpers/commonHelpers');
const pdpHelpers = require('./pdpHelpers');
const recetaHelpers = require('./recetaHelpers');
const isFlowStoreSubscription  = $("input[name='isFlowStoreSubscription']").data('flow-store-subscription');
const astigmatismTxt  = $('.pdp_contacto-astigmatismo-subscription');
const device = window.matchMedia('(max-device-width: 991px)').matches;
const updateRecipeTxt = $('.update_recipe-contact-len');
let isMobile = false;
device ? isMobile = true : false;

let subscriptionPlansDetails;
let normalPriceDecimal;
let innerHtmlPrice;
let outerHtmlSubtotal;
let subscriptionEnabled;
let subscriptionProductEnabled;

function getSelectedPlanDetails() {
    let selectedPlanId = $("#nav-subscription #subscriptionPlansSelect option:selected").val()
    let selectedQuantityEyes = $('input:radio[name=step1]:checked').val();
    let subscriptionPlans = subscriptionPlansDetails[selectedQuantityEyes];
    let planDetail;

    if (subscriptionPlans) {
        planDetail = subscriptionPlans.find((plan) => {
            return plan.planId === selectedPlanId
        });
    }

    return planDetail ? planDetail : null;
}


/**
 *
 * @param {number} selectedQuantityEyes
 */
function updateRecipeView(selectedQuantityEyes) {
    if (pdpHelpers.isTabSuscriptionActive()) {
        $('#nav-subscription .item.quantity').each((index, item) => {
            $(item).hide();
         });

         $('#nav-subscription .item.attr.quantity').hide();

        if (selectedQuantityEyes === 'singleEyePlans' && $('.step1dot1 .step1-options input:checked').val()) {

            const eyeSelector = $('.step1dot1 .step1-options input:checked').val() + '-eye';
            $('#nav-subscription .grid-lentes-config .left-eye, #nav-subscription .grid-lentes-config .right-eye').hide();
            $('#nav-subscription .' + eyeSelector).show();

            if (isFlowStoreSubscription) {
                $('div.subscription-pdp div.grid-lentes-config .' + eyeSelector).css('width','30%');
            }

            $('#nav-subscription div.' + eyeSelector +' div.ojos').css('visibility','hidden');
            $('#nav-subscription .grid-lentes-config').addClass('grid-lentes-config-single-eye-plan');
        } else {
            $('#nav-subscription .grid-lentes-config .left-eye, #nav-subscription .grid-lentes-config .right-eye').show();
            if (isFlowStoreSubscription) {
                $('div.subscription-pdp div.grid-lentes-config .left-eye, div.subscription-pdp div.grid-lentes-config .right-eye').css('width','');
            }
            $('#nav-subscription div.left-eye div.ojos, #nav-subscription div.right-eye div.ojos, .grid-lentes-config').removeClass('grid-lentes-config-single-eye-plan');
        }
    }
}

/**
 *
 * @param {number} selectedQuantityEyes
 */
function populateSubscriptionListSelect(selectedQuantityEyes) {
    let plans = subscriptionPlansDetails[selectedQuantityEyes];
    let selected = $('#subscriptionPlansSelect');
    let optiondefault = selected.data('option-default');

    if (plans) {
        selected.empty();
        selected.removeAttr('selected');
        if (!window.changeSelectPlan) {
            selected.append('<option value="default" selected>' + optiondefault + '</option>');
        }
        for (var index = 0; index < plans.length; index++) {
            var o = $('<option/>', { value: plans[index].planId, class: "option" })
                .text('Recibir cada ' + plans[index].subscriptionFrequency + ' meses (' + plans[index].productQuantity +' cajas)');
            o.appendTo( $('#subscriptionPlansSelect'));
         }
    }
}

/**
 *
 * @param {string} planId
 */
function updatePlanDetailsView(planDetail) {
    if (planDetail) {
        let templateSring = $('.subscriptions_details #firstShipping').data('template');
        let flowStore = $('.subscriptions_details') ? $('.subscriptions_details').data('flow-store') : false;
        templateSring = templateSring.replace('${str0}', planDetail.productQuantity);
        templateSring =templateSring.replace('${str1}', formatDate(new Date()));
        templateSring = templateSring.replace('${str2}', formatDate(addDays(new Date(), planDetail.estimatedDaysRangeForShipping)));
        $('.subscriptions_details #firstShipping').text(templateSring);

        if (planDetail.subscriptionFrequency && planDetail.subscriptionFrequency != '-') {
            let secondDate = addMonths(new Date(), planDetail.subscriptionFrequency);
            secondDate.setDate(1);
            templateSring = $('.subscriptions_details #secondShipping').data('template');
            templateSring = templateSring.replace('${str0}', planDetail.productQuantity);
            templateSring =templateSring.replace('${str1}', formatDate(secondDate));
            templateSring = templateSring.replace('${str2}', formatDate(addDays(secondDate, planDetail.estimatedDaysRangeForShipping)));
            $('.subscriptions_details #secondShipping').text(templateSring);
            templateSring = $('.subscriptions_details #dateNextPayment').data('template');
            templateSring = templateSring.replace('${str0}', planDetail.estimatedDaysRangeForNextPayment);
            $('.subscriptions_details #dateNextPayment').text(templateSring);
            $('.subscriptions_details #nextPayment').text(commonHelpers.formatMoneyToClp(planDetail.unitPrice * planDetail.productQuantity));

        } else {
            $('.subscriptions_details #secondShipping').text('No aplica');
            $('.subscriptions_details #dateNextPayment').text('No aplica');
        }
        if (flowStore === null || flowStore === false) {
            $('.subscriptions_details').removeClass('d-none');
        }
    }
}

function updatePdpPriceDetails(planDetail) {
    if (planDetail && pdpHelpers.isTabSuscriptionActive()) {
        let currentPriceElement = $("#pdpPrices [data-price-template]").find('.sales .value');
        let listPrice = commonHelpers.formatMoneyToClp(normalPriceDecimal)
        let discountedPrice = commonHelpers.formatMoneyToClp(planDetail.unitPrice)
        let savingAmount = normalPriceDecimal - planDetail.unitPrice;

        //discounted price
        if (currentPriceElement) {
            currentPriceElement.text(discountedPrice);
        }

        let currentDelPriceElement = $("#pdpPrices [data-price-template]").find('del');
        if (currentDelPriceElement) {
            currentDelPriceElement.remove();
        }

        //list price
        $('.internet-price').append('<del>' +
            '    <span class="strike-through list">' +
            '        <span class="value reduced" content="' + planDetail.unitPrice + '">' +
                        listPrice  +
            '        </span>' +
            '    </span>' +
            '</del>');


        let currentSavingAmountElement = $(".pdp__texto-cuotas-disponibles").find('.saving-amount');
        if (currentSavingAmountElement) {
            currentSavingAmountElement.remove();
        }

        //saving amount in box
        $(".pdp__texto-cuotas-disponibles p.p-saving-amount").remove();
        $(".pdp__texto-cuotas-disponibles").append(
            '        <p class="p-saving-amount"><span class="saving-amount mt-3" content="' + savingAmount + '">' +
            '           Ahorra <b>' + commonHelpers.formatMoneyToClp(savingAmount)  +'</b> en c/ caja' +
            '        </span></p>'
        );

        const installmentsNumber = $('.pdp_span-cuotas').attr('data-cuotasquantity');
        const installmentsValue = (planDetail.unitPrice / installmentsNumber).toFixed(0);
        $('.pdp_span-cuotas').text(commonHelpers.formatMoneyToClp(installmentsValue));
    }
}

function updatePdpTotalsDetails(planDetail) {
    if (planDetail && pdpHelpers.isTabSuscriptionActive() ) {
        var quantity = planDetail.productQuantity;

        if (quantity > 0) {
            $(".contacto-subtotal").removeClass("d-none");
        } else {
            $(".contacto-subtotal").addClass("d-none");
        }

        $('.contacto-subtotal .subtotal').html(
            '<div class="contacto-pid-price">' +
            + planDetail.productQuantity + ' cajas de ' + $('.pdp__product-name h1').text() + ': <span>'+ commonHelpers.formatMoneyToClp(planDetail.productQuantity * normalPriceDecimal) +'</span>' +
            '</div>' +
            '<div class="contacto-discount"><span>Descuento:  </span><del>' + commonHelpers.formatMoneyToClp((planDetail.productQuantity * normalPriceDecimal) - (planDetail.productQuantity * planDetail.unitPrice)) + '</del></div>' +
            '<div class="d-flex justify-content-end"><div class="line"></div></div>' +
            '<div class="contacto-subtotal-price number">Subtotal: <span data-subtotal>' + commonHelpers.formatMoneyToClp(planDetail.productQuantity * planDetail.unitPrice) + '</span></div>'
        );

    }
}

function updateView(planDetail) {
    let selectedQuantityEyes = $('input:radio[name=step1]:checked').val();
    updatePdpPriceDetails(planDetail);
    if (selectedQuantityEyes) {
        updateRecipeView(selectedQuantityEyes);
    }

    if (planDetail) {
        updatePlanDetailsView(planDetail);
        updatePdpTotalsDetails(planDetail);
    }
}
const SINGLE_EYE_PLAN_VALUE = 'singleEyePlans';
/**
 * select eyes radio buttons handle
 */
function selectEyes() {
    if(subscriptionEnabled === true && subscriptionProductEnabled === true) {
        $('#nav-subscription .step1 input[type="radio"], #nav-subscription .step1dot1 input[type="radio"]').on('click', function (event) {
            let selectedQuantityEyes = $('input:radio[name=step1]:checked').val();

            // Get closest parent div and remove label color
            $(this).closest('.step1-options').find('label').removeClass('active');

            // Change color of label selected eye
            $(this).next('label').addClass('active');

            if (selectedQuantityEyes === SINGLE_EYE_PLAN_VALUE) {
                if (!$("input:radio[name='step1.1']").is(':checked')) {
                        const selected = $('#subscriptionPlansSelect');
                        const optiondefault = selected.data('option-default');

                        $('#subscriptionPlansSelect').attr('disabled', true);
                        $('.step2 .select.select-default select').find('option').attr('disabled', true)

                        $('#subscriptionPlansSelect').append(`<option value="default">
                            ${optiondefault}
                        </option>`);

                        $('.step2 .select.select-default select option[value="default"]').attr("selected",true);
                        $("#subscriptionPlansSelect option").prop("selected", function () {
                            return this.defaultSelected;
                        });

                        $('#hackForDisabledSelector').show();
                        updateView(getSelectedPlanDetails());
                        return;
                }
            }

            $('.step1 .step1-options-error-message').addClass('d-none');
            $('.step1 .step1-options .label').removeClass('invalid');
            $('#subscriptionPlansSelect').removeAttr("disabled");

            //Remove div for click hack in disabled element
            $('#hackForDisabledSelector').hide();
            populateSubscriptionListSelect(selectedQuantityEyes);
            updateView(getSelectedPlanDetails());

            recetaHelpers.displaySelectedEyeRecipeRows();
        });
    }
};

/**
 *
 */
function selectPlan() {
    if(subscriptionEnabled === true && subscriptionProductEnabled === true) {
        $('#nav-subscription .step2 #subscriptionPlansSelect').on('change', function (event) {
            $('option[value=default]').addClass('d-none')
            if ($(this).val() !== 'default') {
                $('#subscriptionPlansSelect').parent().removeClass('select-default');
                window.changeSelectPlan= true;
            } else {
                $('#subscriptionPlansSelect').parent().addClass('select-default');
            }

            updateView(getSelectedPlanDetails());
            recetaHelpers.canBeAddedToCart();
        });
    }
};

/**
 *
 * @param {Date} date
 * @param {int} days
 * @returns
 */
function addDays(date, days) {
    let result = new Date(date);
    result.setDate(date.getDate() + days);
    return result;
}

/**
 *
 * @param {Date} date
 * @param {int} months
 * @returns
 */
function addMonths(date, months) {
    let result = new Date(date);
    result.setMonth(date.getMonth() + months);
    return result;
}

/**
 *
 * @param {Date} objectDate
 * @returns {string}
 */
function formatDate(objectDate) {
    let day = objectDate.getDate();
    let month = objectDate.getMonth() + 1;
    let year = objectDate.getFullYear();

    if (day < 10) {
        day = `0${day}`;
    }

    if (month < 10) {
        month = `0${month}`;
    }

    let format = `${day}.${month}.${year}`;
    return format;
}

/**
 *
 */
function init() {
    subscriptionPlansDetails = $('#nav-subscription').data('subscriptionPlans');
    subscriptionEnabled = $('#nav-subscription').data('subscriptionEnabled');
    subscriptionProductEnabled = $('#nav-subscription').data('subscriptionProductEnabled');

    if(subscriptionEnabled === true && subscriptionProductEnabled === true) {
        innerHtmlPrice = $('.prices .price').html();
        let subtotalDOM = $('.contacto-subtotal');

        if (subtotalDOM && subtotalDOM[0]) {
            outerHtmlSubtotal = subtotalDOM[0].outerHTML;
        }

        let currentPriceElement = $("#pdpPrices [data-price-template]").find('.list .value').length > 0
            ? $("#pdpPrices [data-price-template]").find('.list .value')
            : $("#pdpPrices [data-price-template]").find('.sales .value');

        if (currentPriceElement) {
            normalPriceDecimal = currentPriceElement.attr('content');
        }

        if(!subscriptionPlansDetails) {
            throw new Error('Not subscription plans.');
        }

        let selectedQuantityEyes = $('input:radio[name=step1]:checked').val();
        populateSubscriptionListSelect(selectedQuantityEyes);
        updateView(getSelectedPlanDetails() || Object.values(subscriptionPlansDetails)[0][0]);
    }
};

function selectPurchaseType() {
    if(subscriptionEnabled === true && subscriptionProductEnabled === true) {
        $('a[data-toggle="tab"].tab-subscription-pdp').on('shown.bs.tab', function (e) {
            outerHtmlSubtotal = $('.contacto-subtotal')[0].outerHTML;
            updateView(getSelectedPlanDetails() || Object.values(subscriptionPlansDetails)[0][0]);
            let addToCartButton = $('.add-to-cart-ryk');
            if(addToCartButton && addToCartButton.data('addCartSubscriptionText')) {
                addToCartButton.html(addToCartButton.data('addCartSubscriptionText'));
            }

            let savingElement = $('.saving-amount.pdp');

            if(savingElement && !savingElement.hasClass('d-none')) {
                savingElement.addClass("d-none");
            }

            let promiseShip = $('.promise_ship');

            if(promiseShip && !promiseShip.hasClass('d-none')) {
                promiseShip.addClass("d-none");
            }
            
            if((astigmatismTxt && !astigmatismTxt.hasClass('d-none')) || (updateRecipeTxt && !updateRecipeTxt.hasClass('d-none'))) {
                astigmatismTxt.removeClass("d-flex");
                astigmatismTxt.addClass("d-none");
                if (isMobile) {
                    updateRecipeTxt.removeClass("d-block");
                    updateRecipeTxt.addClass("d-none");
                }
            }

            $('body').trigger('subscription:tabSelected');
            
        });

        $('.tab-buy-one-pdp').on('click', function (event) {
            $('.prices .price').html(innerHtmlPrice);
            $('.contacto-subtotal').replaceWith(outerHtmlSubtotal);
            let addToCartButton = $('.add-to-cart-ryk');
            if(addToCartButton && addToCartButton.data('addCartText')) {
                addToCartButton.html(addToCartButton.data('addCartText'));
            }

            let savingElement = $('.saving-amount.pdp');

            if(savingElement && savingElement.hasClass('d-none')) {
                savingElement.removeClass("d-none");
            }

            let promiseShip = $('.promise_ship');

            if(promiseShip && promiseShip.hasClass('d-none')) {
                promiseShip.removeClass("d-none");
            }

            if((astigmatismTxt && astigmatismTxt.hasClass('d-none')) || (updateRecipeTxt && updateRecipeTxt.hasClass('d-none'))) {
                astigmatismTxt.addClass("d-flex");
                astigmatismTxt.removeClass("d-none");
                if (isMobile) {
                    updateRecipeTxt.addClass("d-block");
                    updateRecipeTxt.removeClass("d-none");
                }
            }

            let subscriptionSavingAmountElement = $(".pdp__texto-cuotas-disponibles").find('.saving-amount');
            if (subscriptionSavingAmountElement) {
                subscriptionSavingAmountElement.remove();
            }

            var installmentsContainer = document.querySelector('.pdp__texto-cuotas-disponibles');
            const price = $('.pdp__prices').find('.sales > .value');
            const installments = $('.pdp_span-cuotas').attr('data-cuotasquantity');
            if (price && price.length === 1) {
              const finalPrice = price.attr('content');
              const installmentsValue = (finalPrice / installments).toFixed(0);
              $('.pdp_span-cuotas').text(commonHelpers.formatMoneyToClp(installmentsValue));
              if (installmentsContainer && installmentsContainer.length > 0) {
                installmentsContainer.style.display = 'block';
              }
            } else {
                if (installmentsContainer && installmentsContainer.length > 0) {
                    installmentsContainer.style.display = 'none';
                }
            }

            $('body').trigger('buyOnePdp:tabSelected');
        });

        if ($('.tab-subscription-pdp').hasClass('active')) {
            $('a[data-toggle="tab"].tab-subscription-pdp').trigger('shown.bs.tab');
            let addToCartButton = $('.add-to-cart-ryk');
            if(addToCartButton && addToCartButton.data('addCartSubscriptionText')) {
                addToCartButton.html(addToCartButton.data('addCartSubscriptionText'));
            }

            $('body').trigger('subscription:tabSelected');
        }
    }
}

module.exports = {
    init: init,
    selectEyes: selectEyes,
    selectPlan: selectPlan,
    selectPurchaseType: selectPurchaseType
};
